webpackJsonp([9],{

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    teachers: function teachers() {
      return window.preload.data.teachers;
    }
  },
  methods: {
    getStyleUrl: function getStyleUrl(url) {
      return 'url(\'' + url + '\')';
    },
    getTeacherDescription: function getTeacherDescription(teacher) {
      return this.$utils.formatParagragh(teacher.description);
    }
  }
});

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48);
__webpack_require__(52);
module.exports = __webpack_require__(477);


/***/ }),

/***/ 477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scripts_bootstrap_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_components_about_teacher_App_vue__ = __webpack_require__(501);






new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__vue_components_about_teacher_App_vue__["a" /* default */]);
  }
});

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_344f838d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(54);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_344f838d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_344f838d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-wrapper"},[_c('navigation-header'),_vm._v(" "),_c('div',{staticClass:"layout-about"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"teachers"},[_c('div',{staticClass:"container"},_vm._l((_vm.teachers),function(teacher){return _c('div',{staticClass:"teacher",attrs:{"id":teacher._id}},[_c('div',{staticClass:"photo",style:({'background-image': _vm.getStyleUrl(teacher.photoUrl)})}),_vm._v(" "),_c('div',{staticClass:"info",class:{highlighted: teacher.isSuperior}},[_c('div',{staticClass:"head"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(teacher.name))]),_vm._v(" "),_c('div',{staticClass:"job-title"},[(teacher.isSuperior)?_c('i',{staticClass:"icon icon-20 icon-medal"}):_vm._e(),_c('span',{staticClass:"text"},[_vm._v(_vm._s(teacher.jobTitle))])])]),_vm._v(" "),_c('div',{staticClass:"desc",domProps:{"innerHTML":_vm._s(_vm.getTeacherDescription(teacher))}})])])}))])]),_vm._v(" "),_c('navigation-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-banner"},[_c('div',{staticClass:"spacer left-with-color"}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"tabs"},[_c('a',{staticClass:"tab",attrs:{"href":"/about"}},[_vm._v("公司简介")]),_vm._v(" "),_c('a',{staticClass:"tab active",attrs:{"href":"/about/teacher"}},[_vm._v("师资团队")])])]),_vm._v(" "),_c('div',{staticClass:"spacer"})])}]


/***/ })

},[476]);


// WEBPACK FOOTER //
// about-teacher.js